import {ColumnsType} from "antd/lib/table/interface";
import React from "react";
import dayjs from "dayjs";
import {Translate} from "../../../../hooks/translate.hook";
import {StatementFile} from "../../../../models/accounting/client-statements";
import {ExpandableConfig} from "antd/es/table/interface";
import {Button, Space} from "antd";

export const columnsFactory = (
    t: Translate,
    reload: (statement: StatementFile) => void,
    loading: boolean,
    generateUri: (uri: string) => string
): ColumnsType<StatementFile & ExpandableConfig<StatementFile>> => {
    return [
        {
            title: t("YEAR"),
            dataIndex: "year",
            key: "year"
        },
        {
            title: t("MONTH"),
            dataIndex: "month",
            key: "month",
            render: month =>
                <>{dayjs().month(month - 1).format('MMM')} ({month})</>
        },
        {
            title: t("FILENAME"),
            dataIndex: "filename",
            key: "filename",
            render: (filename: string, row: StatementFile) =>
                <a href={generateUri("/api/v3/accounting/statements-files/" + row.id + "/" + filename)}>{filename}</a>
        },
        {
            title: t("ACTION"),
            dataIndex: "",
            key: "actions",
            render: (filename: string, row: StatementFile) => (
                <Space direction={"horizontal"}>
                    <Button
                        size={"small"}
                        type={"primary"}
                        loading={loading}
                        onClick={() => reload(row)}
                    >
                        Reload from 1C
                    </Button>
                </Space>
            )
        }
    ];
}